import { IHttpClient } from "@/application/ports";
import { EquipoDTO } from "@/application/dto/equipos/EquipoDTO";
import { EquipoParamsDTO } from "@/application/dto/equipos/EquipoParamsDTO";
import { IEquipoRepository } from "@/domain/repositories/IEquipoRepository";
import type { Equipo } from "@/domain/entities/equipo";
import { API_ENDPOINTS } from "../config/api.config";
import { CreateEquipoDTO } from "@/application/dto/equipos/CreateEquipoDTO";
import { EquipoIdDTO } from "@/application/dto/equipos/EquipoIdDTO";

export class EquipoRepository implements IEquipoRepository {

  constructor(
    private readonly httpClient: IHttpClient
  ) { }
  async findById(
    id: string
  ): Promise<Equipo | null> {

    const response =
      await this.httpClient.get<
        EquipoIdDTO
      >(
        API_ENDPOINTS.equipos.byId(id)
      );

    return this.mapDetalleToEntity(
      response.data
    );
  }
  async create(data: CreateEquipoDTO): Promise<Equipo> {
    const response = await this.httpClient.post<EquipoDTO>(
      API_ENDPOINTS.equipos.base,
      data
    );

    return this.mapToEntity(response.data);
  }
  async update(id: string, data: CreateEquipoDTO): Promise<Equipo> {
    const response = await this.httpClient.put<EquipoDTO>(
      API_ENDPOINTS.equipos.byId(id),
      data
    );

    return this.mapToEntity(response.data);
  }

  async getequipos(params?: EquipoParamsDTO): Promise<Equipo[]> {

    const response = await this.httpClient.get<EquipoDTO[]>(
      API_ENDPOINTS.equipos.base,
      {
        params,
      }
    );

    return response.data.map((dto) => this.mapToEntity(dto));
  }
  private mapToEntity(
    dto: EquipoDTO
  ): Equipo {

    return {
      id: dto.id,
      equipo: dto.equipo,
      estado: dto.estado,
      tipo: dto.tipo,
      lote: dto.lote,
      usuario: "",
      fecha: new Date(),
      ubicacion: dto.ubicacion,
      grupo: "",
      id_lote: 0,
      id_tipo: 0,
      id_ubicacion: 0,
    };
  }
  private mapDetalleToEntity(dto: EquipoIdDTO): Equipo {
    return {
      id: dto.id,
      equipo: dto.equipo,
      estado: dto.estado,
      tipo: dto.tipo,
      lote: dto.lote,
      usuario: dto.usuario,
      fecha: new Date(dto.fecha),
      ubicacion: dto.ubicacion,
      grupo: dto.grupo,
      id_ubicacion: dto.id_ubicacion,
      id_lote: dto.id_lote,
      id_tipo: dto.id_tipo
    };
  }
}
